import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
const BidContext = React.createContext({
  state: { bidList: {}, bid: {} },
  actions: {
    getBid: () => {},
    getBidList: () => {},
  },
});

const BidProvider = ({ children }) => {
  const [bid, setBid] = useState({});
  const [bidList, setBidList] = useState([]);

  const getBidList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/tender/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        tenderNoticeTitle: pageInfo && pageInfo.tenderNoticeTitle,
      },
    }).then((res) => {
      if (res.code === 200) {
        setBidList(res.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getBid = useCallback((bidId) => {
    HttpAction({
      url: "api/admin/tender",
      method: "get",
      params: {
        tenderNoticeId: bidId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setBid(res.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createBid = useCallback(async (bidData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/tender/save`, bidData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getBidList({});
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateBid = useCallback(async (bidData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/tender/modify`, bidData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const deleteBid = useCallback((bidId, history, url) => {
    HttpAction({
      url: "api/admin/tender",
      method: "delete",
      params: {
        tenderNoticeId: bidId,
      },
    }).then((res) => {
      if (res.code === 200) {
        history.push(url);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { bid, bidList },
    actions: { getBidList, getBid, createBid, updateBid, deleteBid },
  };

  return <BidContext.Provider value={value}>{children}</BidContext.Provider>;
};

const { Consumer: BidConsumer } = BidContext;

export { BidProvider, BidConsumer, BidContext };

export default BidContext;
